import type { Attachment, PlanChange } from '../../api/types';
import { strings } from '../../strings';
import { isOutage } from '../runs/runHelpers';

const p = strings.networks.page;

/** A plan component's name for people: "orders-prod · azure / westeurope", "azure · westeurope", "azure". */
export function componentName(
  key: string,
  attachments: readonly Pick<Attachment, 'deploymentId' | 'deploymentName'>[] | undefined,
): string {
  const parts = key.split('/');
  switch (parts[0]) {
    case 'network.attachment': {
      const [, deploymentId, provider, region] = parts;
      const name =
        attachments?.find((a) => a.deploymentId === deploymentId)?.deploymentName ??
        strings.networks.runLabels.aDeployment;
      return p.component.attachment(name, provider, region);
    }
    case 'network.region':
      return p.component.region(parts[1], parts[2]);
    case 'network.zones':
      return parts[1];
    case 'network.entry-point':
      return parts[1] ? strings.networks.runs.entryPointResource(parts[1]) : key;
    default:
      return key;
  }
}

/** Components whose replace or delete interrupts traffic (`outage`) and entry point deletes. */
export function dangerousChanges(changes: readonly PlanChange[] | undefined): PlanChange[] {
  return (changes ?? []).filter(isOutage);
}
